import React, { useRef } from "react";

import { ImagePreview } from "src/common/components/others";

export const ImagesList = ({ list = [] }) => {
  const previewRef = useRef(null);
  return (
    <div className="flex flex-row flex-wrap gap-1">
      {list.map((item) => (
        <React.Fragment key={item?.id}>
          <span
            className="h-8 w-8 rounded-xl overflow-hidden relative aspect-square"
            onClick={() => previewRef.current?.open()}
          >
            <img
              src={item?.path}
              alt=""
              className="h-full w-full inset-0 absolute object-cover"
            />
          </span>
          <ImagePreview imageData={item} ref={previewRef} />
        </React.Fragment>
      ))}
    </div>
  );
};
